import React, { forwardRef, Ref, HTMLAttributes, DetailedHTMLProps } from 'react';
import BEMHelper from 'react-bem-helper';
import './style.less';

const classes = new BEMHelper('Loader');

type LoaderProps = {
    className?: string;
    wrapperClassName?: string;
    modifiers?: string;
} & DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

const Loader = forwardRef(
    (
        { className, modifiers, wrapperClassName, ...props }: LoaderProps,
        ref: Ref<HTMLDivElement>
    ) => (
        <div {...classes('wrapper', '', wrapperClassName)} ref={ref}>
            <div {...props} {...classes('', modifiers, className)} />
        </div>
    )
);

Loader.displayName = 'Loader';

export default Loader;
